/** Code the fuel cell reports when no error or warning is present. */
export const FUEL_CELL_CODE_NONE = '000.000';

/** Displayed value of a fuel cell error or warning code. */
export function getFuelCellCodeString(code?: string): string {
    if (!code || code === FUEL_CELL_CODE_NONE) {
        return '-';
    }
    return code;
}

export enum FuelCellSystemState {

    off,
    standby,
    inOperation,
    shutDown,
    frostProtection,
    deepDischargeProtection,
    transportLockProcedure,
    transportLock,
    reset,
    factoryDefaults,
    error,
    frostProtection2,
    pending,
    pending2,
    updateEfoyAccessoires
}

export function getFuelCellSystemStateString(FuelCell: FuelCellSystemState): string {
    switch (FuelCell) {
        case FuelCellSystemState.off:
            return 'Offline'
        case FuelCellSystemState.standby:
            return 'Standby'
        case FuelCellSystemState.inOperation:
            return 'In Betrieb'
        case FuelCellSystemState.shutDown:
            return 'Shut Down'
        case FuelCellSystemState.frostProtection:
            return 'Frost Protection'
        case FuelCellSystemState.deepDischargeProtection:
            return 'Deep Discharge Protection'
        case FuelCellSystemState.transportLockProcedure:
            return 'TransportLock Procedure'
        case FuelCellSystemState.transportLock:
            return 'TransportLock'
        case FuelCellSystemState.reset:
            return 'Reset'
        case FuelCellSystemState.factoryDefaults:
            return 'Factory Defaults'
        case FuelCellSystemState.error:
            return 'Error'
        case FuelCellSystemState.frostProtection2:
            return 'Frost Protection2'
        case FuelCellSystemState.pending:
            return 'Pending'
        case FuelCellSystemState.pending2:
            return 'Pending2'
        case FuelCellSystemState.updateEfoyAccessoires:
            return 'Update Efoy Accessoires'
    }
}
/** Reason why the fuel cell was last switched on. */
export enum FuelCellSwitchOnReason {
    Keiner = 0,
    Manuell = 1,
    AutoBatterie = 2,
    AutoFrostschutz = 3,
    AutoTiefentladeschutz = 4,
}

export function getFuelCellSwitchOnReasonString(reason: FuelCellSwitchOnReason): string {
    switch (reason) {
        case FuelCellSwitchOnReason.Keiner:
            return '-';
        case FuelCellSwitchOnReason.Manuell:
            return 'Manuell';
        case FuelCellSwitchOnReason.AutoBatterie:
            return 'Auto Batteriestatus';
        case FuelCellSwitchOnReason.AutoFrostschutz:
            return 'Auto Frostschutz';
        case FuelCellSwitchOnReason.AutoTiefentladeschutz:
            return 'Auto Tiefentladeschutz';
        default:
            return String(reason);
    }
}

/** Reason why the fuel cell was last switched off. */
export enum FuelCellSwitchOffReason {
    Keiner = 0,
    Manuell = 1,
    AutoBatterie = 2,
    AutoMaxLadezeit = 3,
    AutoUeberspannung = 4,
    AutoFrostschutz = 5,
    AutoKeinTreibstoff = 6,
    AutoReservoirLeer = 7,
    Fehler = 8,
    Reset = 9,
}

export function getFuelCellSwitchOffReasonString(reason: FuelCellSwitchOffReason): string {
    switch (reason) {
        case FuelCellSwitchOffReason.Keiner:
            return '-';
        case FuelCellSwitchOffReason.Manuell:
            return 'Manuell';
        case FuelCellSwitchOffReason.AutoBatterie:
            return 'Auto Batteriestatus';
        case FuelCellSwitchOffReason.AutoMaxLadezeit:
            return 'Auto max. Ladezeit';
        case FuelCellSwitchOffReason.AutoUeberspannung:
            return 'Auto Überspannung';
        case FuelCellSwitchOffReason.AutoFrostschutz:
            return 'Auto Frostschutz';
        case FuelCellSwitchOffReason.AutoKeinTreibstoff:
            return 'Auto kein Treibstoff';
        case FuelCellSwitchOffReason.AutoReservoirLeer:
            return 'Auto Reservoir leer';
        case FuelCellSwitchOffReason.Fehler:
            return 'Fehler';
        case FuelCellSwitchOffReason.Reset:
            return 'Reset';
        default:
            return String(reason);
    }
}
